import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_SECRET;

const toUrlSafe = (base64) =>
  base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const fromUrlSafe = (safe) =>
  safe.replace(/-/g, "+").replace(/_/g, "/") +
  "=".repeat((4 - (safe.length % 4)) % 4);

export const encrypt = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
  return toUrlSafe(encrypted);
};

export const decrypt = (ciphertext) => {
  const normalCipher = fromUrlSafe(ciphertext)
  const bytes = CryptoJS.AES.decrypt(normalCipher, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
